'use strict' /* eslint-disable no-console */;

/**
 * resourcesMenu 1) sets up an active menu state
 * when a user is on a specific Resources subpage, and
 * 2) sets up the mobile view for the Resources homepage
 */

const resourcesMenu = (function() {
  const activeClass = 'js-is-active';
  const homeClass = 'resources__home';

  /**
   * setActiveMenu
   *
   * Adds active classes to reveal the specific subpage
   * in the Resources menu that the user is on
   *
   * @param currentPath: current URL path
   * @param menuItems: all menu items (checked against current URL subpath)
   */
  function setActiveMenu(currentPath, menuItems) {
    menuItems.forEach((item) => {
      if (item.href.includes(currentPath)) {
        item.parentNode.parentNode.parentNode.children[0].classList.add(
          activeClass
        );
        item.parentNode.parentNode.classList.add(activeClass);
        item.classList.add(activeClass);
        // update aria labels
        // trigger
        item.parentNode.parentNode.parentNode.children[0].setAttribute(
          'aria-expanded',
          'true'
        );
        // content
        item.parentNode.parentNode.setAttribute('aria-hidden', 'false');
      }
    });
  }

  /**
   * setMobileHomepage
   *
   * Adds classes to expand the Resources menu by default
   * when visiting the Resources homepage on mobile
   *
   * @param wrapper: parent Resources element
   * @param accordionContent: top level accordion content wrapper
   */
  function setMobileHomepage(wrapper, accordionContent) {
    wrapper.classList.add(homeClass);
    accordionContent.classList.add(activeClass);
  }

  function init() {
    const currentPath = window.location.pathname;
    const resourcesMenuItems = document.querySelectorAll(
      '.resources__nav--sub-link'
    );
    const resourcesWrapper = document.querySelector('.resources');
    const resourcesAccordionContent = document.querySelector(
      '.resources__nav > .accordion__trigger + .accordion__content'
    );

    // check if visiting a Resources subpage or Resources homepage
    if (currentPath.split('/').length > 2) {
      setActiveMenu(currentPath, resourcesMenuItems);
    } else if (currentPath === '/resources') {
      setMobileHomepage(resourcesWrapper, resourcesAccordionContent);
    }
  }

  window.addEventListener('DOMContentLoaded', init);
})();

export default resourcesMenu;



// WEBPACK FOOTER //
// ./resources/assets/js/resources-menu.js